<template>
    <div class="ObjectPrice">
        <div class="ObjectPrice__main-content">
            <div :class="[{'ObjectPrice__rise-icon' : priceRise !== 'eq'}, {'ObjectPrice__rise-icon--up': priceRise === 'up'}]">
                <ArrowIcon v-if="priceRise !== 'eq'"/>
            </div>
            <div class="ObjectPrice__value ObjectPrice__main-value">{{getPriceString(currentVal)}}</div>
        </div>
        <div class="ObjectPrice__more-info-wrapper" v-if="priceRise !== 'eq'">
            <MoreInfoIcon />
            <div class="ObjectPrice__more-info">
                <div class="ObjectPrice__more-info-content">
                    <div class="ObjectPrice__item">
                        <div class="ObjectPrice__label">Старая цена</div>
                        <div class="ObjectPrice__price">
                            <div class="ObjectPrice__value">
                                {{getPriceString(prevVal, false)}}
                            </div>
                        </div>
                    </div>
                    <div :class="['ObjectPrice__big-arrow',{'ObjectPrice__rise-icon--up': priceRise === 'up'}]">
                        <BigArrowIcon />
                    </div>
                    <div class="ObjectPrice__item">
                        <div class="ObjectPrice__label">Новая цена</div>
                        <div class="ObjectPrice__price">
                            <div class="ObjectPrice__value">
                                {{getPriceString(currentVal, false)}}
                            </div>
                        </div>
                    </div>
                </div>
                <MoreInfoArrowIcon class="ObjectPrice__more-info-arrow" />
            </div>
        </div>
    </div>
</template>

<script>

import ArrowIcon from '@/assets/image/icons/price-arrow-down.svg?inline'
import BigArrowIcon from '@/assets/image/icons/price-big-arrow-down.svg?inline'
import MoreInfoIcon from '@/assets/image/icons/more-info.svg?inline'
import MoreInfoArrowIcon from '@/assets/image/icons/price-info-arrow.svg?inline'
import {mapGetters} from "vuex";

const currencySymbol = {
  RUR: '₽',
  USD: '$',
  EUR: '€',
}

export default {
    name: "ObjectPrice",
    components: {
        ArrowIcon,
        BigArrowIcon,
        MoreInfoIcon,
        MoreInfoArrowIcon,
    },
    props: {
        current: Object,
        prev: Object,
        fullPrice: {
            type: Boolean,
            default: false,
        },
        tp: Number
    },
    computed: {
        currentVal(){
            console.log( this.current);
          return this.current[this.currency];
        },
        /*currSym() {
            return currencySymbol[this.currency];
        },*/
        prevVal(){
          return this.prev[this.currency];
        },
        priceRise() {
            if (this.currentVal > this.prevVal) {
                return 'up';
            } else {
                if (this.currentVal < this.prevVal) {
                    return 'down';
                } else {
                    return 'eq';
                }
            }
            //return this.currentVal > this.prevVal;
        },
      ...mapGetters(['currency'])
    },
    methods: {
        getPriceString(value, fullPrice = this.fullPrice) {
            value = Number(value);

            if (value === 0) {
                return 'цена по запросу';
            }

            let shortPrice = value;

            if (value > 1000000) {
                shortPrice = `${(value / 1000000).toFixed(1).replace('.', ',').replace(/(,0+|0+)$/, '')} млн ${currencySymbol[this.currency]}`;
            } else {
                shortPrice = `${(value / 1000).toFixed(1).replace('.', ',').replace(/(,0+|0+)$/, '')} тыс ${currencySymbol[this.currency]}`;
            }

            let pr = fullPrice ? `${value.toLocaleString()} ${currencySymbol[this.currency]}` : shortPrice;

            if (this.tp === 3) {
              pr = pr + ' / мес.';
            }

            return pr;
        },
    }
}
</script>

<style lang="scss">
.ObjectPrice {
  display: flex;
  align-items: center;

  &__main-content {
    margin-right: 8px;
    display: flex;
    align-items: center;
  }

  &__value {
    font-size: 20px;
    font-weight: 500;
    color: $textBlack;
    margin-right: 4px;
    white-space: nowrap;
  }

  &__rise-icon {
    padding-bottom: 10px;

    &--up svg {
      transform: scaleY(-1);

      path {
        fill: $secondary;
      }
    }
  }

  &__more-info-wrapper {
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;

    &:hover {
      .ObjectPrice__more-info {
        display: block;
      }
    }
  }

  &__more-info {
    z-index: 11;

    display: none;
    position: absolute;
    left: 50%;
    bottom: 100%;
    transform: translate(-50%, -8px);

    padding: 16px;
    border-radius: 8px;
    background-color: $textLightBlack;

    box-shadow: $BlockShadow;

    &::before {
      z-index: -1;
      content: '';
      position: absolute;
      top: -10px;
      bottom: -30px;
      left: -15px;
      right: -15px;
    }

    &:hover {
      display: block;
    }
  }

  &__more-info-content {
    display: flex;
    align-items: center;
  }

  &__more-info-arrow {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
  }

  &__item {

    .ObjectPrice__value {
      color: $white;
      white-space: nowrap;
    }
  }

  &__price {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;

    @include svgFill($gray);

  }

  &__label {
    color: rgba($white, 0.4);
    line-height: 20px;
  }

  &__big-arrow {
    padding: 0 15px;
  }
}
</style>
